import { ASSUMPTION_GAPS } from '../../data/conjointData';
import { AlertTriangle } from 'lucide-react';
import { InfoButton } from '../common/Tooltip';

export function RiskSummary() {
  const highRisks = ASSUMPTION_GAPS.filter(g => g.riskLevel === 'HIGH');

  return (
    <div className="card card-accent-red">
      <div className="flex items-center gap-2 mb-4">
        <AlertTriangle size={16} className="text-metric-negative" />
        <h3 className="text-heading font-semibold text-secondary uppercase tracking-wider">Key Risks: Model vs. Reality</h3>
        <InfoButton helpKey="riskSummary" size={13} />
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="border-b border-border/40">
              <th className="py-2 pr-3 text-left text-micro text-muted uppercase tracking-wider font-semibold w-8">Risk</th>
              <th className="py-2 px-3 text-left text-micro text-muted uppercase tracking-wider font-semibold">Metric</th>
              <th className="py-2 px-3 text-left text-micro text-muted uppercase tracking-wider font-semibold">Financial Model</th>
              <th className="py-2 px-3 text-left text-micro text-muted uppercase tracking-wider font-semibold">Conjoint Evidence</th>
              <th className="py-2 pl-3 text-left text-micro text-muted uppercase tracking-wider font-semibold">Gap</th>
            </tr>
          </thead>
          <tbody>
            {highRisks.map(gap => (
              <tr key={gap.metric} className="border-b border-border/20">
                <td className="py-2.5 pr-3">
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-micro font-bold bg-red-500/20 text-red-400 ring-1 ring-red-500/30">
                    HIGH
                  </span>
                </td>
                <td className="py-2.5 px-3 text-sm text-primary font-medium">{gap.metric}</td>
                <td className="py-2.5 px-3 text-xs text-secondary font-mono">{gap.financialModel}</td>
                <td className="py-2.5 px-3 text-xs text-secondary font-mono">{gap.conjointEvidence}</td>
                <td className="py-2.5 pl-3 text-xs text-metric-negative font-medium">{gap.gap}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
